import type { ModuleDefinition } from '../../../app/moduleRegistry';
import UserListPage from './pages/UserListPage';

/** Sistem kullanıcısı yönetimi — Master GSA only. */
export const userModule: ModuleDefinition = {
  routes: [{ path: 'system/user', element: <UserListPage /> }],
  menuItems: [
    {
      label: 'Sistem: Kullanıcılar',
      path: 'system/user',
      isVisible: (user) => !!user?.isMasterGsa,
    },
  ],
};
